import { Component } from '@theme/component';

const CACHE_TTL = 120000;
const MAX_CACHE_ENTRIES = 8;
const responseCache = new Map();
const inFlightRequests = new Map();
let googleLogoInstance = 0;

const GOOGLE_SOURCE_BADGE_SVG = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" focusable="false" aria-hidden="true"><path fill="currentColor" d="M6.757.236a.35.35 0 0 1 .486 0l1.106 1.07a.35.35 0 0 0 .329.089l1.493-.375a.35.35 0 0 1 .422.244l.422 1.48a.35.35 0 0 0 .24.24l1.481.423a.35.35 0 0 1 .244.422l-.375 1.493a.35.35 0 0 0 .088.329l1.071 1.106a.35.35 0 0 1 0 .486l-1.07 1.106a.35.35 0 0 0-.089.329l.375 1.493a.35.35 0 0 1-.244.422l-1.48.422a.35.35 0 0 0-.24.24l-.423 1.481a.35.35 0 0 1-.422.244l-1.493-.375a.35.35 0 0 0-.329.088l-1.106 1.071a.35.35 0 0 1-.486 0l-1.106-1.07a.35.35 0 0 0-.329-.089l-1.493.375a.35.35 0 0 1-.422-.244l-.422-1.48a.35.35 0 0 0-.24-.24l-1.481-.423a.35.35 0 0 1-.244-.422l.375-1.493a.35.35 0 0 0-.088-.329L.236 7.243a.35.35 0 0 1 0-.486l1.07-1.106a.35.35 0 0 0 .089-.329L1.02 3.829a.35.35 0 0 1 .244-.422l1.48-.422a.35.35 0 0 0 .24-.24l.423-1.481a.35.35 0 0 1 .422-.244l1.493.375a.35.35 0 0 0 .329-.088L6.757.236Z"></path><path fill="#fff" fill-rule="evenodd" d="M9.065 4.85a.644.644 0 0 1 .899 0 .615.615 0 0 1 .053.823l-.053.059L6.48 9.15a.645.645 0 0 1-.84.052l-.06-.052-1.66-1.527a.616.616 0 0 1 0-.882.645.645 0 0 1 .84-.052l.06.052 1.21 1.086 3.034-2.978Z" clip-rule="evenodd"></path></svg>';

const GOOGLE_LOGO_SVG = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true"><g clip-path="url(#a-32)"><path fill="#fff" stroke="#fff" stroke-linejoin="round" stroke-width="2" d="M11.854 1.023c5.965 0 10.8 4.836 10.8 10.8v.4c0 5.965-4.835 10.8-10.8 10.8-5.964 0-10.8-4.835-10.8-10.8v-.4c0-5.964 4.836-10.8 10.8-10.8Z"></path><path fill="url(#b-34)" d="M6.382 13.906a6.04 6.04 0 0 1-.307-1.909H1.998c0 1.517.343 2.946.947 4.227l.124.254v.009a10.063 10.063 0 0 0 1.889 2.604l4.47-1.674a6.119 6.119 0 0 1-3.046-3.511Z"></path><path fill="url(#c-35)" d="M18.672 4.607c-1.734-1.618-3.987-2.609-6.684-2.609-.531 1.11-.62 2.771 0 3.981 1.471 0 2.78.51 3.824 1.491l2.86-2.863Z"></path><path fill="url(#d-36)" d="M11.988 5.979h.095L11.988 2a9.936 9.936 0 0 0-7.645 3.576c.257 1.483.97 2.435 3.12 2.586 1.084-1.324 2.709-2.182 4.525-2.182Z"></path><path fill="url(#e-37)" d="M15.357 17.06c-.89.6-2.025.963-3.369.963-.784 1.263-1.31 2.562 0 3.972 2.529 0 4.674-.783 6.295-2.139l.317-.278c1.483-1.37 2.473-3.244 2.83-5.46.099-.607.149-1.24.149-1.894l-2.265.3-1.913 1.35-.036.177a4.596 4.596 0 0 1-1.813 2.871l-.194.138Z"></path><path fill="#3086FF" d="M11.997 10.183v3.863l5.368.005a4.958 4.958 0 0 1-.014.067h4.08a11.894 11.894 0 0 0-.034-3.94h-6.9v.005h-2.5Z"></path><path fill="url(#f-38)" d="m6.322 10.324.072-.227A6.136 6.136 0 0 1 8.112 7.48c-.93-.157-3.262-1.525-3.566-2.14a10.066 10.066 0 0 0-1.477 2.174A9.885 9.885 0 0 0 2 12.21c.723.312 3.082.37 4.08 0a5.927 5.927 0 0 1 .243-1.885Z"></path><path fill="url(#g-39)" d="m8.03 2.816 1.713 3.623c-.754.322-1.43.8-1.99 1.392l-3.77-1.798A10.016 10.016 0 0 1 8.03 2.816Z"></path><path fill="url(#h-40)" d="M11.988 18.023a5.733 5.733 0 0 1-3.047-.878l-1.56-.043c-1.84.488-2.373.882-2.54 1.872a9.934 9.934 0 0 0 7.147 3.021v-3.972Z"></path><path fill="url(#i-33)" d="M11.988 21.995c.421 0 .832-.021 1.231-.064v-4.016c-.388.07-.799.108-1.231.108-.412 0-.814-.044-1.202-.128v4.029c.394.047.795.071 1.202.071Z" opacity=".5"></path></g><defs><radialGradient id="b-34" cx="0" cy="0" r="1" gradientTransform="matrix(-.39757 -10.0208 14.2942 -.60134 9.338 18.94)" gradientUnits="userSpaceOnUse"><stop offset=".142" stop-color="#1ABD4D"></stop><stop offset=".248" stop-color="#6EC30D"></stop><stop offset=".312" stop-color="#8AC502"></stop><stop offset=".366" stop-color="#A2C600"></stop><stop offset=".446" stop-color="#C8C903"></stop><stop offset=".54" stop-color="#EBCB03"></stop><stop offset=".616" stop-color="#F7CD07"></stop><stop offset=".699" stop-color="#FDCD04"></stop><stop offset=".771" stop-color="#FDCE05"></stop><stop offset=".861" stop-color="#FFCE0A"></stop></radialGradient><radialGradient id="c-35" cx="0" cy="0" r="1" gradientTransform="matrix(6.98036 -.00002 -.00001 8.69591 18.395 7.264)" gradientUnits="userSpaceOnUse"><stop offset=".408" stop-color="#FB4E5A"></stop><stop offset="1" stop-color="#FF4540"></stop></radialGradient><radialGradient id="d-36" cx="0" cy="0" r="1" gradientTransform="matrix(-9.6911 5.28673 7.28367 12.9529 14.733 .725)" gradientUnits="userSpaceOnUse"><stop offset=".231" stop-color="#FF4541"></stop><stop offset=".312" stop-color="#FF4540"></stop><stop offset=".458" stop-color="#FF4640"></stop><stop offset=".54" stop-color="#FF473F"></stop><stop offset=".699" stop-color="#FF5138"></stop><stop offset=".771" stop-color="#FF5B33"></stop><stop offset=".861" stop-color="#FF6C29"></stop><stop offset="1" stop-color="#FF8C18"></stop></radialGradient><radialGradient id="e-37" cx="0" cy="0" r="1" gradientTransform="matrix(-17.1717 -22.6188 -8.27422 6.39593 12.223 20.718)" gradientUnits="userSpaceOnUse"><stop offset=".132" stop-color="#0CBA65"></stop><stop offset=".21" stop-color="#0BB86D"></stop><stop offset=".297" stop-color="#09B479"></stop><stop offset=".396" stop-color="#08AD93"></stop><stop offset=".477" stop-color="#0AA6A9"></stop><stop offset=".568" stop-color="#0D9CC6"></stop><stop offset=".667" stop-color="#1893DD"></stop><stop offset=".769" stop-color="#258BF1"></stop><stop offset=".801" stop-color="#3086FF"></stop></radialGradient><radialGradient id="f-38" cx="0" cy="0" r="1" gradientTransform="matrix(-1.20389 10.4771 14.3476 1.68068 10.996 3.988)" gradientUnits="userSpaceOnUse"><stop offset=".366" stop-color="#FF4E3A"></stop><stop offset=".458" stop-color="#FF8A1B"></stop><stop offset=".54" stop-color="#FFA312"></stop><stop offset=".616" stop-color="#FFB60C"></stop><stop offset=".771" stop-color="#FFCD0A"></stop><stop offset=".861" stop-color="#FECF0A"></stop><stop offset=".915" stop-color="#FECF08"></stop><stop offset="1" stop-color="#FDCD01"></stop></radialGradient><radialGradient id="g-39" cx="0" cy="0" r="1" gradientTransform="matrix(-3.50897 3.94947 -10.9461 -10.0722 9.372 3.77)" gradientUnits="userSpaceOnUse"><stop offset=".316" stop-color="#FF4C3C"></stop><stop offset=".604" stop-color="#FF692C"></stop><stop offset=".727" stop-color="#FF7825"></stop><stop offset=".885" stop-color="#FF8D1B"></stop><stop offset="1" stop-color="#FF9F13"></stop></radialGradient><radialGradient id="h-40" cx="0" cy="0" r="1" gradientTransform="matrix(-9.59911 -5.20571 7.21454 -12.7543 14.685 23.19)" gradientUnits="userSpaceOnUse"><stop offset=".231" stop-color="#0FBC5F"></stop><stop offset=".312" stop-color="#0FBC5F"></stop><stop offset=".366" stop-color="#0FBC5E"></stop><stop offset=".458" stop-color="#0FBC5D"></stop><stop offset=".54" stop-color="#12BC58"></stop><stop offset=".699" stop-color="#28BF3C"></stop><stop offset=".771" stop-color="#38C02B"></stop><stop offset=".861" stop-color="#52C218"></stop><stop offset=".915" stop-color="#67C30F"></stop><stop offset="1" stop-color="#86C504"></stop></radialGradient><linearGradient id="i-33" x1="10.786" x2="13.219" y1="19.945" y2="19.945" gradientUnits="userSpaceOnUse"><stop stop-color="#0FBC5C"></stop><stop offset="1" stop-color="#0CBA65"></stop></linearGradient><clipPath id="a-32"><path fill="#fff" d="M0 0h24v24H0z"></path></clipPath></defs></svg>';

// Rating fills communicate the numeric score; geometry is shared with theme stars.
const RATING_STAR_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" /></svg>';

function renderRatingStars(element) {
  const track = document.createElement('span');
  track.className = 'google-reviews-block__star-track';
  track.setAttribute('aria-hidden', 'true');
  for (let index = 0; index < 5; index += 1) {
    track.append(createTrustedSvg(RATING_STAR_SVG, 'google-reviews-block__star'));
  }
  const fill = track.cloneNode(true);
  fill.className = 'google-reviews-block__star-fill';
  element.replaceChildren(track, fill);
}

function createTrustedSvg(markup, className) {
  const template = document.createElement('template');
  template.innerHTML = markup;
  const svg = template.content.firstElementChild;
  svg.classList.add(className);
  return svg;
}

function createGoogleSourceBadge() {
  return createTrustedSvg(GOOGLE_SOURCE_BADGE_SVG, 'google-reviews-block__source-badge');
}

function createGoogleLogo(className) {
  const id = `google-reviews-logo-${++googleLogoInstance}`;
  const markup = GOOGLE_LOGO_SVG
    .replaceAll('a-32', `${id}-clip`)
    .replaceAll('b-34', `${id}-b`)
    .replaceAll('c-35', `${id}-c`)
    .replaceAll('d-36', `${id}-d`)
    .replaceAll('e-37', `${id}-e`)
    .replaceAll('f-38', `${id}-f`)
    .replaceAll('g-39', `${id}-g`)
    .replaceAll('h-40', `${id}-h`)
    .replaceAll('i-33', `${id}-i`);
  return createTrustedSvg(markup, className);
}

function createGoogleAvatarLogo() {
  return createGoogleLogo('google-reviews-block__avatar-logo');
}

function createGoogleHeaderLogo() {
  return createGoogleLogo('google-reviews-block__brand-mark');
}

function normalizeRating(value) {
  const rating = Number(value);
  return Number.isFinite(rating) ? Math.min(5, Math.max(0, rating)) : 0;
}

function setRatingFill(element, rating) {
  const fill = Number(((normalizeRating(rating) / 5) * 100).toFixed(2));
  element.style.setProperty('--google-reviews-star-fill', `${fill}%`);
}

function getGoogleReviewsPaginationAnchors(slideCount, visibleCount) {
  const count = Math.max(0, Number(slideCount) || 0);
  if (!count) return [];

  const size = Math.max(1, Math.min(Number(visibleCount) || 1, count));
  const lastAnchor = Math.max(0, count - size);
  const anchors = [];

  for (let anchor = 0; anchor <= lastAnchor; anchor += size) {
    anchors.push(anchor);
  }

  if (anchors.at(-1) !== lastAnchor) anchors.push(lastAnchor);

  return anchors;
}

function getGoogleReviewsPaginationIndex(currentIndex, anchors) {
  let activeIndex = 0;
  anchors.forEach((anchor, index) => {
    if (currentIndex >= anchor) activeIndex = index;
  });
  return activeIndex;
}

function createAbortError() {
  return new DOMException('The request was aborted.', 'AbortError');
}

/**
 * Fit a chooser to the visible viewport, preferring below when its capped content fits.
 * Native anchors own trigger attachment; these bounds also serve the CSS fallback.
 * @param {DOMRect} trigger
 * @param {{ top: number, bottom: number, left: number, right: number }} viewport
 * @param {number} contentHeight Includes the popover's borders.
 * @param {number} contentWidth
 * @param {number} gap
 * @param {number} edge
 * @param {boolean} [rtl]
 */
function getGoogleReviewsPickerPlacement(trigger, viewport, contentHeight, contentWidth, gap, edge, rtl = false) {
  if (trigger.bottom <= viewport.top || trigger.top >= viewport.bottom) return null;

  const width = Math.max(0, Math.min(contentWidth, viewport.right - viewport.left - edge * 2));
  const desiredHeight = Math.min(contentHeight, (viewport.bottom - viewport.top) * 0.45);
  const below = Math.max(0, viewport.bottom - edge - trigger.bottom - gap);
  const above = Math.max(0, trigger.top - gap - viewport.top - edge);
  const placement = desiredHeight > below && above > below ? 'above' : 'below';
  const maxHeight = Math.min(desiredHeight, placement === 'above' ? above : below);
  if (width <= 0 || maxHeight <= 0) return null;
  const left = Math.max(viewport.left + edge, Math.min(
    rtl ? trigger.right - width : trigger.left,
    viewport.right - edge - width
  ));

  return {
    placement, width, left, maxHeight,
    top: placement === 'above' ? trigger.top - gap - maxHeight : trigger.bottom + gap,
  };
}

function parseStoreIds(value) {
  return [...new Set(
    String(value || '')
      .split(/[\n,\r]+/)
      .map((id) => id.trim())
      .filter(Boolean)
  )];
}

function getApiBase(endpoint) {
  const url = new URL(endpoint, document.baseURI);
  if (!['http:', 'https:'].includes(url.protocol)) {
    throw new Error('Google Reviews endpoint must use HTTP or HTTPS.');
  }

  const reviewsIndex = url.pathname.indexOf('/reviews');
  url.pathname = reviewsIndex >= 0 ? url.pathname.slice(0, reviewsIndex) : url.pathname;
  url.search = '';
  url.hash = '';

  return url.toString().replace(/\/$/, '');
}

function getCachedResponse(url) {
  const entry = responseCache.get(url);
  if (!entry) return null;

  if (Date.now() - entry.createdAt > CACHE_TTL) {
    responseCache.delete(url);
    return null;
  }

  return entry.value;
}

function setCachedResponse(url, value) {
  responseCache.delete(url);
  responseCache.set(url, { createdAt: Date.now(), value });

  while (responseCache.size > MAX_CACHE_ENTRIES) {
    responseCache.delete(responseCache.keys().next().value);
  }
}

function waitForAbort(promise, signal) {
  if (signal.aborted) return Promise.reject(createAbortError());

  return new Promise((resolve, reject) => {
    const handleAbort = () => reject(createAbortError());

    signal.addEventListener('abort', handleAbort, { once: true });
    promise.then(
      (value) => {
        signal.removeEventListener('abort', handleAbort);
        resolve(value);
      },
      (error) => {
        signal.removeEventListener('abort', handleAbort);
        reject(error);
      }
    );
  });
}

function requestJson(url, signal) {
  const cached = getCachedResponse(url);
  if (cached) return Promise.resolve(cached);

  let request = inFlightRequests.get(url);
  if (!request) {
    request = fetch(url, {
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Google Reviews request failed (${response.status}).`);
        return response.json();
      })
      .then((value) => {
        setCachedResponse(url, value);
        return value;
      })
      .finally(() => inFlightRequests.delete(url));

    inFlightRequests.set(url, request);
  }

  return waitForAbort(request, signal);
}

function normalizeLocations(payload) {
  if (Array.isArray(payload?.locations)) {
    return payload.locations.map((location) => ({
      ...location,
      reviews: Array.isArray(location.reviews) ? location.reviews : [],
    }));
  }

  if (payload?.location) {
    return [{
      ...payload.location,
      reviews: Array.isArray(payload.reviews) ? payload.reviews : [],
    }];
  }

  return [];
}

/**
 * Maps the ProductReview service answer (`{ ok, summary: { ratingAvg, reviewCount }, items[] }`)
 * onto the review shape the cards already render. The summary always describes the whole listing,
 * not only the reviews the service returned.
 */
function normalizeProductReview(payload) {
  const items = Array.isArray(payload?.items) ? payload.items : [];
  return {
    rating: Number(payload?.summary?.ratingAvg),
    reviewCount: Number(payload?.summary?.reviewCount),
    reviews: items
      .map((item) => ({
        author: String(item?.author || '').trim(),
        createdAt: item?.date || '',
        rating: normalizeRating(item?.rating),
        title: String(item?.heading || '').trim(),
        comment: String(item?.body || '').trim(),
      }))
      .filter((review) => review.comment),
  };
}

function getSummaryValue(location, key) {
  return Number(location?.summary?.[key] ?? location?.[key] ?? 0);
}

function summarizeLocations(locations, fallback = null) {
  const reviewCount = locations.reduce((total, location) => {
    return total + getSummaryValue(location, 'reviewCount');
  }, 0);

  if (!reviewCount) {
    return {
      rating: Number(fallback?.rating || 0).toFixed(1),
      reviewCount: Number(fallback?.reviewCount || 0),
    };
  }

  const weightedRating = locations.reduce((total, location) => {
    return total + getSummaryValue(location, 'rating') * getSummaryValue(location, 'reviewCount');
  }, 0);

  return {
    rating: (weightedRating / reviewCount).toFixed(1),
    reviewCount,
  };
}

function safeExternalUrl(value) {
  if (!value) return '';

  try {
    const url = new URL(value, document.baseURI);
    return url.protocol === 'https:' ? url.href : '';
  } catch {
    return '';
  }
}

/** Preserve the legacy chooser's store URL priority without changing selected-showroom links. */
function resolveGoogleReviewsWriteLocations(locations, stores, preferStoreUrls = false) {
  const storeById = new Map((stores || []).map((store) => [String(store.id), store]));

  return (locations || []).map((location) => {
    const store = storeById.get(String(location.id));
    const locationWriteReviewUrl = safeExternalUrl(location.writeReviewUrl);
    const storeWriteReviewUrl = safeExternalUrl(store?.writeReviewUrl);
    const writeReviewUrl = preferStoreUrls
      ? storeWriteReviewUrl || locationWriteReviewUrl
      : locationWriteReviewUrl || storeWriteReviewUrl;
    if (!writeReviewUrl) return null;

    return {
      ...location,
      name: location.name || location.title || store?.name || store?.title || String(location.id),
      writeReviewUrl,
    };
  }).filter(Boolean);
}

/** Choose identities from the committed feed, independently of its aggregate review total. */
function selectGoogleReviewAvatars(reviews, limit = 4) {
  const items = [];
  const seen = new Set();
  for (const review of reviews || []) {
    const author = String(review.author || '').trim();
    const avatar = safeExternalUrl(review.avatar);
    const identity = `${author.toLocaleLowerCase()}|${avatar}`;
    if ((!author && !avatar) || seen.has(identity)) continue;
    seen.add(identity);
    items.push({ author, avatar });
    if (items.length >= limit) break;
  }
  return items;
}

function getInitials(name) {
  return String(name || 'G')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join('')
    .toUpperCase() || 'G';
}

class GoogleReviewsBlock extends Component {
  #controller = null;

  #requestController = null;

  #generation = 0;

  #isLoading = false;

  #configSignature = '';

  #apiBase = '';

  #allowedStoreIds = [];

  #stores = [];

  #storesOverall = null;

  #locations = [];

  #currentReviews = [];

  #currentSummary = null;

  #selection = 'all';

  #slideshow = null;

  #pagination = null;

  #paginationAnchors = [];

  #paginationResizeObserver = null;

  #paginationFrame = null;

  #expandedQuotes = new Set();

  #quoteFrame = null;

  #quoteAnimations = new Map();

  #quoteMotionObserver = null;

  /** Defers the first network request until the block approaches the viewport. */
  /** @type {IntersectionObserver | null} */
  #nearViewportObserver = null;

  #reviewTextStates = new WeakMap();

  /** @type {HTMLElement | null} */
  #status = null;

  /** @type {HTMLElement | null} */
  #carousel = null;

  /** @type {HTMLElement | null} */
  #actionsHome = null;

  #brandLogo = null;

  /** @type {HTMLElement | null} */
  #actions = null;

  /** @type {HTMLElement | null} */
  #summary = null;

  /** @type {HTMLElement | null} */
  #summaryRating = null;

  /** @type {HTMLElement | null} */
  #summaryStars = null;

  /** @type {HTMLElement | null} */
  #summaryCount = null;

  #summaryAvatarItems = null;

  #avatarSignature = '';

  /** @type {HTMLElement | null} */
  #locationSelectWrap = null;

  /** @type {HTMLSelectElement | null} */
  #locationSelect = null;

  /** @type {HTMLButtonElement | null} */
  #chooseButton = null;

  /** @type {HTMLAnchorElement | null} */
  #writeLink = null;

  /** @type {HTMLElement | null} */
  #picker = null;

  /** @type {HTMLElement | null} */
  #pickerList = null;

  #pickerOpen = false;

  /** @type {AbortController | null} */
  #pickerTrackingController = null;

  /** @type {number | null} */
  #pickerFrame = null;

  /** @type {HTMLTemplateElement | null} */
  #controlsTemplate = null;

  /** @type {HTMLTemplateElement | null} */
  #locationIconTemplate = null;

  connectedCallback() {
    super.connectedCallback();

    this.#controller?.abort();
    this.#controller = new AbortController();
    this.#configSignature = this.#getConfigSignature();
    this.#cacheElements();

    const { signal } = this.#controller;
    this.addEventListener('click', this.#handleClick, { signal });
    this.addEventListener('click', this.#handleSlideshowControlClick, { capture: true, signal });
    this.addEventListener('change', this.#handleChange, { signal });
    this.addEventListener('scroll', this.#handleQuoteScroll, { capture: true, passive: true, signal });
    this.addEventListener('slideshow:select', this.#handleSlideshowSelect, { signal });
    window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', this.#resolveQuoteMotionPolicy, { signal });
    this.#quoteMotionObserver?.disconnect();
    this.#quoteMotionObserver = new MutationObserver(this.#resolveQuoteMotionPolicy);
    this.#quoteMotionObserver.observe(document.body, { attributes: true, attributeFilter: ['data-motion'] });

    this.#loadWhenNearViewport();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#cacheElements();

    const signature = this.#getConfigSignature();
    if (signature === this.#configSignature) {
      this.#applyQuoteTypography();
      this.#scheduleQuoteRefresh();
      if (this.#currentReviews.length) {
        this.#renderSummary(this.#currentSummary);
        this.#renderActions(this.#locations);
      }
      if (this.#currentReviews.length && !this.#carousel?.querySelector('slideshow-component')) {
        const generation = this.#generation;
        this.#renderSlideshow(this.#currentReviews, generation).then(() => {
          if (this.#isCurrent(generation) && !this.#isLoading) this.#setReady();
        });
      } else if (this.#currentReviews.length && !this.#isLoading) {
        this.#setReady();
      }
      return;
    }

    this.#configSignature = signature;
    this.#loadWhenNearViewport();
  }

  disconnectedCallback() {
    this.#generation += 1;
    this.#nearViewportObserver?.disconnect();
    this.#nearViewportObserver = null;
    this.#controller?.abort();
    this.#controller = null;
    this.#quoteMotionObserver?.disconnect();
    this.#quoteMotionObserver = null;
    this.#requestController?.abort();
    this.#requestController = null;
    this.#restoreActionsToHome();
    this.#stopPickerTracking(true);
    this.#stopPaginationTracking();
    this.#slideshow?.remove();
    this.#slideshow = null;
    this.#currentReviews = [];
    this.#currentSummary = null;
    this.#renderSummaryAvatars([]);
    const controlsHost = this.querySelector('[data-google-reviews-summary-controls]');
    if (controlsHost) { controlsHost.replaceChildren(); controlsHost.hidden = true; }
    super.disconnectedCallback();
  }

  #cacheElements() {
    this.#status = this.querySelector('[data-google-reviews-status]');
    this.#carousel = this.querySelector('[data-google-reviews-carousel]');
    this.#actionsHome = this.querySelector('[data-google-reviews-actions-home]');
    this.#brandLogo = this.querySelector('[data-google-reviews-brand-logo]');
    if (this.#brandLogo && !this.#brandLogo.firstElementChild) {
      this.#brandLogo.append(createGoogleHeaderLogo());
    }
    this.#actions = this.querySelector('[data-google-reviews-actions]');
    this.#summary = this.querySelector('[data-google-reviews-summary]');
    this.#summaryRating = this.querySelector('[data-google-reviews-summary-rating]');
    this.#summaryStars = this.querySelector('[data-google-reviews-summary-stars]');
    this.#summaryCount = this.querySelector('[data-google-reviews-summary-count]');
    this.#summaryAvatarItems = this.querySelector('[data-google-reviews-avatars] .avatar-group__items');
    this.#locationSelectWrap = this.querySelector('[data-google-reviews-location-select-wrap]');
    this.#locationSelect = this.querySelector('[data-google-reviews-location-select]');
    this.#chooseButton = this.querySelector('[data-google-reviews-choose]');
    this.#writeLink = this.querySelector('[data-google-reviews-write-link]');
    const picker = this.querySelector('[data-google-reviews-picker]');
    this.#picker?.removeEventListener('beforetoggle', this.#handlePickerToggle);
    if (picker !== this.#picker) {
      this.#stopPickerTracking(true);
      this.#pickerOpen = false;
    }
    this.#picker = picker;
    if (this.#controller) {
      this.#picker?.addEventListener('beforetoggle', this.#handlePickerToggle, { signal: this.#controller.signal });
    }
    this.#pickerList = this.querySelector('[data-google-reviews-picker-list]');
    this.#controlsTemplate = this.querySelector('[data-google-reviews-controls]');
    this.#locationIconTemplate = this.querySelector('[data-google-reviews-location-icon]');
  }

  #restoreActionsToHome() {
    this.#closePicker();
  }

  #getConfigSignature() {
    return [
      this.dataset.endpoint,
      this.dataset.allowedStoreIds,
      this.dataset.limit,
      this.dataset.hideLocationSelect,
      this.dataset.source,
      this.dataset.listing,
    ].join('|');
  }

  /** ProductReview mode reads one listing through the review service; every other value is Google. */
  #isProductReview() {
    return this.dataset.source === 'productreview';
  }

  /**
   * Starts loading once the block is within 400px of the viewport. The reserved skeleton keeps
   * layout stable meanwhile; the Theme Editor and browsers without IntersectionObserver load at once.
   */
  #loadWhenNearViewport() {
    this.#nearViewportObserver?.disconnect();
    this.#nearViewportObserver = null;

    if (globalThis.Shopify?.designMode || typeof IntersectionObserver !== 'function') {
      this.#load();
      return;
    }

    this.#nearViewportObserver = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.#nearViewportObserver?.disconnect();
        this.#nearViewportObserver = null;
        this.#load();
      },
      { rootMargin: '400px 0px' }
    );
    this.#nearViewportObserver.observe(this);
  }

  async #load() {
    // The loading skeleton pulses from here on; until the block is near the screen it holds still (CSS).
    this.toggleAttribute('data-near-viewport', true);
    this.#requestController?.abort();
    this.#requestController = new AbortController();
    const { signal } = this.#requestController;
    const generation = ++this.#generation;

    this.#setLoading();

    if (this.#isProductReview()) {
      try {
        const payload = await requestJson(this.#productReviewUrl(), signal);
        if (!this.#isCurrent(generation)) return;
        if (payload?.ok !== true) throw new Error('ProductReview request failed.');
        await this.#commitProductReview(normalizeProductReview(payload), generation);
      } catch (error) {
        if (error?.name === 'AbortError' || !this.#isCurrent(generation)) return;
        this.#setProductReviewFallback();
      }
      return;
    }

    try {
      this.#apiBase = getApiBase(this.dataset.endpoint);
      this.#allowedStoreIds = parseStoreIds(this.dataset.allowedStoreIds);

      const storesPayload = await requestJson(`${this.#apiBase}/stores`, signal);
      if (!this.#isCurrent(generation)) return;

      this.#stores = (storesPayload.stores || []).filter((store) => {
        return !this.#allowedStoreIds.length || this.#allowedStoreIds.includes(String(store.id));
      });
      this.#storesOverall = storesPayload.overall || null;
      this.#selection = this.#allowedStoreIds.length === 1 ? this.#allowedStoreIds[0] : 'all';
      this.#renderLocationOptions();

      const locations = await this.#fetchLocations(this.#selection, signal);
      if (!this.#isCurrent(generation)) return;

      await this.#commitLocations(locations, generation);
    } catch (error) {
      if (error?.name === 'AbortError' || !this.#isCurrent(generation)) return;
      this.#setError();
    }
  }

  async #loadSelection(selection) {
    this.#requestController?.abort();
    this.#requestController = new AbortController();
    const { signal } = this.#requestController;
    const generation = ++this.#generation;
    this.#selection = selection;
    this.#closePicker(true);
    this.#setLoading();

    try {
      const locations = await this.#fetchLocations(selection, signal);
      if (!this.#isCurrent(generation)) return;
      await this.#commitLocations(locations, generation);
    } catch (error) {
      if (error?.name === 'AbortError' || !this.#isCurrent(generation)) return;
      this.#setError();
    }
  }

  async #fetchLocations(selection, signal) {
    if (selection === 'all' && this.#allowedStoreIds.length) {
      const payloads = await Promise.all(
        this.#allowedStoreIds.map((id) => requestJson(this.#reviewsUrl(id), signal))
      );

      return payloads.flatMap((payload) => normalizeLocations(payload));
    }

    const payload = await requestJson(this.#reviewsUrl(selection), signal);
    return normalizeLocations(payload);
  }

  #reviewsUrl(storeId) {
    return `${this.#apiBase}/reviews?store=${encodeURIComponent(storeId)}`;
  }

  /** `{endpoint}?url=<listing>&limit=<n>`; the service keeps its own rating filter and cache. */
  #productReviewUrl() {
    const url = new URL(this.dataset.endpoint, document.baseURI);
    if (url.protocol !== 'https:') throw new Error('ProductReview endpoint must use HTTPS.');
    url.searchParams.set('url', this.dataset.listing || '');
    url.searchParams.set('limit', this.dataset.limit || '16');
    return url.toString();
  }

  /**
   * Shows the listing's rating and its reviews. With a rating but no reviews to scroll, only the
   * summary stays; with neither, the block hides.
   */
  async #commitProductReview({ rating, reviewCount, reviews }, generation) {
    await customElements.whenDefined('slideshow-component');
    if (!this.#isCurrent(generation)) return;

    const summaryRating = rating > 0 ? rating : Number(this.dataset.fallbackRating);
    if (!(summaryRating > 0) && !reviews.length) {
      this.#setUnavailable();
      return;
    }

    this.#locations = [];
    this.#stores = [];
    this.#currentReviews = reviews.slice(0, Number(this.dataset.limit || 16));
    this.#currentSummary = {
      rating: normalizeRating(summaryRating).toFixed(1),
      reviewCount: Number.isFinite(reviewCount) && reviewCount > 0 ? reviewCount : 0,
    };
    this.#renderSummary(this.#currentSummary);
    this.#renderActions(this.#locations);

    if (!this.#currentReviews.length) {
      this.#setSummaryOnly();
      return;
    }

    await this.#renderSlideshow(this.#currentReviews, generation);
    if (this.#isCurrent(generation)) this.#setReady();
  }

  /** The service failed: keep the rating saved with the listing (URL||rating), otherwise hide. */
  #setProductReviewFallback() {
    const rating = Number(this.dataset.fallbackRating);
    if (!(rating > 0)) {
      this.#setUnavailable();
      return;
    }

    this.#currentReviews = [];
    this.#currentSummary = { rating: normalizeRating(rating).toFixed(1), reviewCount: 0 };
    this.#renderSummary(this.#currentSummary);
    this.#renderActions([]);
    this.#setSummaryOnly();
  }

  /** "Read all reviews" link to the listing; the showroom chooser and select stay hidden. */
  #renderProductReviewAction() {
    const listingUrl = safeExternalUrl(this.dataset.listing);
    this.#closePicker(true);
    this.#chooseButton.hidden = true;
    this.#actions.hidden = true;
    this.#writeLink.hidden = !listingUrl;
    if (listingUrl) {
      this.#writeLink.href = listingUrl;
      this.#writeLink.target = '_blank';
      this.#writeLink.rel = 'noopener noreferrer';
    }
    this.#actionsHome.hidden = !listingUrl;
  }

  async #commitLocations(locations, generation) {
    await customElements.whenDefined('slideshow-component');
    if (!this.#isCurrent(generation)) return;
    this.#locations = locations;
    const reviews = locations
      .flatMap((location) => (location.reviews || []).map((review) => ({
        ...review,
        locationName: location.name,
        mapsUrl: location.mapsUrl,
      })))
      .filter((review) => review.comment)
      .sort((a, b) => {
        return new Date(b.updatedAt || b.createdAt) - new Date(a.updatedAt || a.createdAt);
      })
      .slice(0, Number(this.dataset.limit || 16));

    this.#renderLocationOptions();
    this.#currentSummary = summarizeLocations(locations, this.#storesOverall);
    this.#currentReviews = reviews;
    this.#renderSummary(this.#currentSummary);
    this.#renderActions(locations);

    if (!reviews.length) {
      this.#currentReviews = [];
      this.#setEmpty();
      return;
    }

    await this.#renderSlideshow(reviews, generation);
    if (this.#isCurrent(generation)) this.#setReady();
  }

  #renderLocationOptions() {
    if (!(this.#locationSelect instanceof HTMLSelectElement)) return;

    const showSelect = this.dataset.hideLocationSelect === 'false' && this.#stores.length > 1;
    this.#locationSelectWrap.hidden = !showSelect;
    this.#locationSelect.replaceChildren();

    const allOption = document.createElement('option');
    allOption.value = 'all';
    allOption.textContent = this.dataset.allStoresLabel;
    this.#locationSelect.append(allOption);

    this.#stores.forEach((store) => {
      const option = document.createElement('option');
      option.value = String(store.id);
      option.textContent = store.name || store.title || String(store.id);
      this.#locationSelect.append(option);
    });

    this.#locationSelect.value = this.#selection;
  }

  #renderActions(locations) {
    if (this.#isProductReview()) {
      this.#renderProductReviewAction();
      return;
    }

    const isShowroomChooser = this.#selection === 'all' && locations.length !== 1;
    const writeReviewLocations = resolveGoogleReviewsWriteLocations(locations, this.#stores, isShowroomChooser);
    const currentLocation = isShowroomChooser
      ? null
      : writeReviewLocations[0] || locations[0];
    const writeReviewUrl = safeExternalUrl(currentLocation?.writeReviewUrl)
      || (writeReviewLocations.length === 1 ? safeExternalUrl(writeReviewLocations[0].writeReviewUrl) : '');
    const showSelect = this.dataset.hideLocationSelect === 'false' && this.#stores.length > 1;
    const showChooser = !writeReviewUrl && writeReviewLocations.length > 1;

    this.#writeLink.hidden = !writeReviewUrl;
    if (writeReviewUrl) {
      this.#writeLink.href = writeReviewUrl;
      this.#writeLink.target = '_blank';
      this.#writeLink.rel = 'noopener noreferrer';
    } else {
      this.#writeLink.removeAttribute('href');
      this.#writeLink.removeAttribute('target');
      this.#writeLink.removeAttribute('rel');
    }

    this.#closePicker(true);
    this.#chooseButton.hidden = !showChooser;
    this.#chooseButton.textContent = this.dataset.writeReviewLabel;
    this.#actions.hidden = !showSelect && !showChooser;
    this.#actionsHome.hidden = !showSelect && !showChooser && this.#writeLink.hidden;
    if (showChooser) this.#renderPicker(writeReviewLocations);
  }

  #renderPicker(locations) {
    if (!(this.#pickerList instanceof HTMLElement)) return;
    this.#closePicker(true);
    this.#pickerList.replaceChildren();

    (locations || []).forEach((location) => {
      const link = document.createElement('a');
      link.className = 'google-reviews-picker__button';
      link.href = location.writeReviewUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = location.name || location.title || String(location.id);
      link.addEventListener('click', () => this.#closePicker());
      this.#pickerList.append(link);
    });
  }

  async #renderSlideshow(reviews, generation) {
    this.#restoreActionsToHome();
    this.#stopPaginationTracking();
    await customElements.whenDefined('slideshow-component');
    if (!this.#isCurrent(generation)) return;

    const slideshow = document.createElement('slideshow-component');
    slideshow.className = 'google-reviews-block__slideshow';
    slideshow.setAttribute('auto-hide-controls', '');
    // The shared position control; the block stylesheet shows it on phones only, where the rail has no arrows.
    slideshow.setAttribute('show-scrollbar', '');
    slideshow.setAttribute('scrollbar-label', this.dataset.scrollbarLabel || '');

    const container = document.createElement('slideshow-container');
    container.setAttribute('ref', 'slideshowContainer');

    const slides = document.createElement('slideshow-slides');
    slides.setAttribute('ref', 'scroller');
    slides.tabIndex = -1;

    reviews.forEach((review, index) => {
      const slide = document.createElement('slideshow-slide');
      slide.setAttribute('ref', 'slides[]');
      slide.setAttribute('slide-id', `google-review-${index}`);
      slide.setAttribute('aria-hidden', String(index !== 0));
      slide.className = 'google-reviews-block__slide';
      slide.append(this.#createCard(review, index));
      slides.append(slide);
    });

    // Arrows sit over the review rail (shown on hover and focus); on wider screens the dots in the summary card are
    // the position control.
    if (this.#controlsTemplate instanceof HTMLTemplateElement) {
      const controls = this.#controlsTemplate.content.cloneNode(true);
      controls.querySelectorAll('.google-reviews-block__arrows .slideshow-control').forEach((button) => {
        button.removeAttribute('on:click');
      });
      container.append(controls, slides);
    } else {
      container.append(slides);
    }

    const pagination = this.#createPagination();
    slideshow.append(container);
    const host = this.querySelector('[data-google-reviews-summary-controls]');
    host?.replaceChildren(pagination);
    if (host) host.hidden = false;
    this.#carousel.replaceChildren(slideshow);
    // The rail is replaced on every render, so its listener goes with it.
    slides.addEventListener('scroll', this.#handleRailScroll, { passive: true });
    slides.addEventListener('scrollend', this.#handleRailScroll, { passive: true });
    this.#slideshow = slideshow;
    this.#pagination = pagination;
    this.#scheduleQuoteRefresh();
    if (typeof ResizeObserver === 'function') {
      this.#paginationResizeObserver = new ResizeObserver((entries) => {
        this.#scheduleQuoteRefresh();
        if (entries.some(({ target }) => target === container)) this.#schedulePaginationRefresh();
      });
      this.#paginationResizeObserver.observe(container);
    }
    await new Promise((resolve) => requestAnimationFrame(resolve));
    if (this.#isCurrent(generation)) this.#refreshPagination();
  }

  #createPagination() {
    const pagination = document.createElement('nav');
    pagination.className = 'google-reviews-block__pagination';
    pagination.dataset.googleReviewsPagination = 'true';
    pagination.setAttribute('aria-label', this.dataset.paginationLabel);
    pagination.hidden = true;

    // Dots are the list's own items (the shared button-only dots variant): the active state sits on the item itself,
    // so the graded sizes come from plain sibling selectors that every engine re-evaluates when it moves.
    const list = document.createElement('div');
    list.className = 'google-reviews-block__pagination-list slideshow-controls__dots';
    list.setAttribute('role', 'group');
    pagination.append(list);
    return pagination;
  }

  #getSlideshowSlides() {
    return this.#slideshow?.slides || Array.from(this.#slideshow?.querySelectorAll('slideshow-slide') || []);
  }

  #getVisibleSlideCount(slides) {
    const scroller = this.#slideshow?.querySelector('slideshow-slides');
    if (!(scroller instanceof HTMLElement)) return 1;

    const firstRect = slides[0]?.getBoundingClientRect();
    if (!firstRect?.width) return 1;

    // Capacity follows the padded layout, not a partially scrolled resize frame.
    const rail = scroller.getBoundingClientRect();
    const styles = getComputedStyle(scroller);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    const padding = (parseFloat(styles.paddingLeft) || 0) + (parseFloat(styles.paddingRight) || 0);
    const contentWidth = Math.max(0, rail.width - padding);
    const capacity = Math.floor((contentWidth + gap + 1) / (firstRect.width + gap));
    return Math.max(1, Math.min(capacity, slides.length));
  }

  #getPaginationState() {
    const slides = this.#getSlideshowSlides();
    if (!slides.length) return { anchors: [], visibleCount: 1 };

    const visibleCount = this.#getVisibleSlideCount(slides);
    return {
      anchors: getGoogleReviewsPaginationAnchors(slides.length, visibleCount),
      visibleCount,
    };
  }

  #getActivePageIndex(currentIndex = this.#slideshow?.current || 0) {
    return getGoogleReviewsPaginationIndex(currentIndex, this.#paginationAnchors);
  }

  #refreshPagination() {
    if (!(this.#pagination instanceof HTMLElement)) return;

    this.#refreshMobileBleed();
    this.#scheduleQuoteRefresh();
    const { anchors, visibleCount } = this.#getPaginationState();
    const list = this.#pagination.querySelector('.google-reviews-block__pagination-list');
    if (!(list instanceof HTMLElement)) return;

    const signature = anchors.join(',');
    const anchorsChanged = this.#pagination.dataset.anchorSignature !== signature;
    if (anchorsChanged) {
      list.replaceChildren();
      const statusTemplate = this.dataset.slideStatusLabel || 'Slide __INDEX__ of __LENGTH__';

      anchors.forEach((anchor, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'slideshow-control button button-unstyled slideshow-controls__dot';
        button.dataset.googleReviewsPage = String(index);
        button.setAttribute('aria-label', statusTemplate
          .replace('__INDEX__', String(index + 1))
          .replace('__LENGTH__', String(anchors.length)));
        button.addEventListener('click', this.#handlePaginationClick);
        list.append(button);
      });

      this.#pagination.dataset.anchorSignature = signature;
    }

    this.#paginationAnchors = anchors;
    this.#pagination.dataset.visibleCount = String(visibleCount);
    if (anchorsChanged) list.scrollLeft = 0;
    list.dataset.overflow = String(list.scrollWidth > list.clientWidth);
    this.#pagination.hidden = anchors.length <= 1;
    this.#setPaginationActive();
  }

  #setPaginationActive(currentIndex = this.#slideshow?.current || 0) {
    if (!(this.#pagination instanceof HTMLElement) || !this.#paginationAnchors.length) return;
    const host = this.querySelector('[data-google-reviews-summary-controls]');

    const activeIndex = this.#getActivePageIndex(currentIndex);
    this.#updateArrowStates(activeIndex);
    if (host) host.hidden = this.#paginationAnchors.length <= 1;
    const list = this.#pagination.querySelector('.google-reviews-block__pagination-list');
    this.#pagination.querySelectorAll('[data-google-reviews-page]').forEach((button, index) => {
      const selected = index === activeIndex;
      if (selected) button.setAttribute('aria-current', 'page');
      else button.removeAttribute('aria-current');

      if (selected && list instanceof HTMLElement && list.scrollWidth > list.clientWidth) {
        const listRect = list.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();
        if (buttonRect.left < listRect.left) list.scrollLeft -= listRect.left - buttonRect.left;
        if (buttonRect.right > listRect.right) list.scrollLeft += buttonRect.right - listRect.right;
      }
    });
  }

  /**
   * Previous/Next follow the rail's real scroll position (±1px for sub-pixel ends), so a drag, wheel or swipe
   * that moves the rail never leaves an arrow disabled while it can still scroll. Without overflow the page
   * index decides.
   * @param {number} [activeIndex]
   */
  #updateArrowStates(activeIndex = this.#getActivePageIndex()) {
    const previous = this.querySelector('.google-reviews-block__arrows .slideshow-control--previous');
    const next = this.querySelector('.google-reviews-block__arrows .slideshow-control--next');
    const scroller = this.#slideshow?.querySelector('slideshow-slides');
    const maximum = scroller instanceof HTMLElement ? scroller.scrollWidth - scroller.clientWidth : 0;
    if (maximum > 1) {
      const position = Math.abs(scroller.scrollLeft);
      if (previous) previous.disabled = position <= 1;
      if (next) next.disabled = position >= maximum - 1;
      return;
    }
    if (previous) previous.disabled = activeIndex === 0;
    if (next) next.disabled = activeIndex === this.#paginationAnchors.length - 1;
  }

  #arrowStateFrame = null;

  #handleRailScroll = () => {
    if (this.#arrowStateFrame !== null) return;
    this.#arrowStateFrame = requestAnimationFrame(() => {
      this.#arrowStateFrame = null;
      if (this.isConnected && this.#paginationAnchors.length) this.#updateArrowStates();
    });
  };

  #schedulePaginationRefresh = () => {
    if (this.#paginationFrame !== null) return;
    this.#paginationFrame = requestAnimationFrame(() => {
      this.#paginationFrame = null;
      if (this.isConnected) this.#refreshPagination();
    });
  };

  // Quote scrolling updates affordances only; carousel pagination has its own geometry owner.
  #handleQuoteScroll = (event) => {
    if (this.#expandedQuotes.has(event.target)) this.#scheduleQuoteRefresh();
  };

  #scheduleQuoteRefresh = () => {
    if (!this.#expandedQuotes.size || this.#quoteFrame !== null) return;
    this.#quoteFrame = requestAnimationFrame(() => {
      this.#quoteFrame = null;
      const states = [...this.#expandedQuotes].map((region) => ({
        region,
        // Transforms can temporarily enlarge scrollHeight; measure only settled content.
        more: !this.#quoteAnimations.has(region.nextElementSibling)
          && region.scrollHeight - region.clientHeight - region.scrollTop > 1,
      }));
      states.forEach(({ region, more }) => {
        region.parentElement?.toggleAttribute('data-quote-more-below', more);
      });
    });
  };

  /** Measure the stable inner frame so nested padding cannot constrain the mobile rail. */
  #refreshMobileBleed() {
    const properties = ['--google-reviews-bleed-start', '--google-reviews-bleed-end'];
    if (!window.matchMedia('(max-width: 749px)').matches) {
      properties.forEach((property) => this.style.removeProperty(property));
      return;
    }

    const frame = this.#carousel?.parentElement;
    if (!frame) return;
    const rect = frame.getBoundingClientRect();
    if (!rect.width) return;
    const viewport = document.documentElement.clientWidth;
    const rtl = getComputedStyle(this).direction === 'rtl';
    const offsets = [
      Math.max(0, rtl ? viewport - rect.right : rect.left),
      Math.max(0, rtl ? rect.left : viewport - rect.right),
    ];
    properties.forEach((property, index) => {
      const value = String(offsets[index]) + 'px';
      if (this.style.getPropertyValue(property) !== value) this.style.setProperty(property, value);
    });
  }

  #stopPaginationTracking() {
    this.#cancelQuoteMotions();
    this.#expandedQuotes.forEach((region) => region.parentElement?.removeAttribute('data-quote-more-below'));
    this.#expandedQuotes.clear();
    if (this.#quoteFrame !== null) cancelAnimationFrame(this.#quoteFrame);
    this.#quoteFrame = null;
    this.#paginationResizeObserver?.disconnect();
    this.#paginationResizeObserver = null;
    if (this.#paginationFrame !== null) cancelAnimationFrame(this.#paginationFrame);
    this.#paginationFrame = null;
    if (this.#arrowStateFrame !== null) cancelAnimationFrame(this.#arrowStateFrame);
    this.#arrowStateFrame = null;
    this.#pagination = null;
    this.#paginationAnchors = [];
    this.style.removeProperty('--google-reviews-bleed-start');
    this.style.removeProperty('--google-reviews-bleed-end');
  }

  #handlePaginationClick = (event) => {
    const button = event.currentTarget;
    if (!(button instanceof HTMLElement) || !this.#slideshow) return;

    const pageIndex = Number(button.dataset.googleReviewsPage);
    const anchor = this.#paginationAnchors[pageIndex];
    if (!Number.isInteger(anchor)) return;

    this.#slideshow.select(anchor, event);
  };

  #handleSlideshowControlClick = (event) => {
    const target = event.target instanceof Element
      ? event.target.closest('.google-reviews-block__arrows .slideshow-control')
      : null;
    if (!(target instanceof HTMLButtonElement) || !this.#slideshow || !this.contains(target)) return;
    if (target.disabled || !this.#paginationAnchors.length) return;

    const direction = target.classList.contains('slideshow-control--previous')
      ? -1
      : target.classList.contains('slideshow-control--next')
        ? 1
        : 0;
    if (!direction) return;

    const currentPage = this.#getActivePageIndex();
    const nextPage = Math.max(0, Math.min(currentPage + direction, this.#paginationAnchors.length - 1));
    const anchor = this.#paginationAnchors[nextPage];
    if (!Number.isInteger(anchor)) return;

    event.preventDefault();
    event.stopPropagation();
    this.#slideshow.select(anchor, event);
  };

  #handleSlideshowSelect = (event) => {
    if (!this.#slideshow?.contains(event.target)) return;
    this.#scheduleQuoteRefresh();
    this.#setPaginationActive(event.detail?.index);
  };

  get quotePreset() {
    return ['paragraph', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'custom'].includes(this.dataset.quoteTypePreset)
      ? this.dataset.quoteTypePreset : 'paragraph';
  }

  #applyQuoteTypography() {
    const presets = ['paragraph', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
    for (const text of this.#slideshow?.querySelectorAll('.google-reviews-block__quote-text') || []) {
      text.classList.remove(...presets);
      text.classList.add(this.quotePreset);
    }
  }

  #createCard(review, index = 0) {
    const card = document.createElement('article');
    const identityAtBottom = index % 2 === 1;
    card.className = `google-reviews-block__card${identityAtBottom ? ' google-reviews-block__card--identity-bottom' : ''}`;

    const header = document.createElement('header');
    header.className = 'google-reviews-block__card-header';

    const avatar = document.createElement('div');
    avatar.className = 'google-reviews-block__avatar';
    const avatarUrl = safeExternalUrl(review.avatar);
    if (avatarUrl) {
      const image = document.createElement('img');
      image.src = avatarUrl;
      image.alt = review.author || '';
      image.loading = 'lazy';
      image.referrerPolicy = 'no-referrer';
      avatar.append(image);
    } else {
      avatar.textContent = getInitials(review.author);
    }

    // Google marks are Google-only; ProductReview cards carry no source badge.
    const isGoogle = !this.#isProductReview();
    if (isGoogle) {
      const sourceLink = document.createElement('a');
      sourceLink.className = 'google-reviews-block__source-link';
      const sourceLabel = document.createElement('span');
      sourceLabel.className = 'visually-hidden';
      sourceLabel.textContent = this.dataset.sourceLabel;
      sourceLink.append(createGoogleAvatarLogo(), sourceLabel);
      const mapsUrl = safeExternalUrl(review.mapsUrl);
      if (mapsUrl) {
        sourceLink.href = mapsUrl;
        sourceLink.target = '_blank';
        sourceLink.rel = 'noopener noreferrer';
      } else {
        sourceLink.removeAttribute('href');
      }
      avatar.append(sourceLink);
    }

    const identity = document.createElement('div');
    identity.className = 'google-reviews-block__identity';
    const nameRow = document.createElement('div');
    nameRow.className = 'google-reviews-block__name-row';

    const name = document.createElement('span');
    name.className = 'google-reviews-block__name';
    name.textContent = review.author || this.dataset.authorFallbackLabel;

    nameRow.append(name);
    if (isGoogle) {
      const sourceIcon = document.createElement('span');
      sourceIcon.className = 'google-reviews-block__source-icon';
      sourceIcon.setAttribute('role', 'img');
      sourceIcon.setAttribute('aria-label', this.dataset.sourceLabel);
      sourceIcon.append(createGoogleSourceBadge());
      nameRow.append(sourceIcon);
    }

    const date = document.createElement('time');
    date.className = 'google-reviews-block__date';
    date.dateTime = review.updatedAt || review.createdAt || '';
    date.textContent = this.#formatDate(review.updatedAt || review.createdAt);
    identity.append(nameRow, date);

    const rating = normalizeRating(review.rating);
    header.append(avatar, identity);
    const body = document.createElement('div');
    body.className = 'google-reviews-block__card-body';

    const quote = document.createElement('blockquote');
    quote.className = 'google-reviews-block__quote';
    const text = String(review.comment || '').trim();
    const shortText = text.length > 145 ? `${text.slice(0, 145).trim()}...` : text;
    const textElement = document.createElement('p');
    textElement.className = `google-reviews-block__quote-text text-block ${this.quotePreset}`;
    textElement.textContent = shortText;
    const scrollRegion = document.createElement('div');
    scrollRegion.className = 'google-reviews-block__quote-scroll';
    scrollRegion.append(textElement);
    const title = isGoogle ? '' : String(review.title || '').trim();
    if (title) {
      // Review titles are feed content; textContent keeps them literal. Inside the scroll region the title
      // stays above the text when expanded and scrolls with it.
      const titleElement = document.createElement('p');
      titleElement.className = 'google-reviews-block__quote-title';
      titleElement.textContent = title;
      scrollRegion.prepend(titleElement);
    }
    quote.append(scrollRegion);

    if (shortText !== text) {
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'google-reviews-block__read-more';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = this.dataset.readMoreLabel;
      this.#reviewTextStates.set(toggle, { textElement, scrollRegion, shortText, fullText: text });
      quote.append(toggle);
    }

    const footer = document.createElement('footer');
    footer.className = 'google-reviews-block__card-footer';

    // Showroom names are feed content; textContent keeps them literal and safe to display.
    const locationName = String(review.locationName || '').trim();
    if (locationName) {
      const location = document.createElement('div');
      location.className = 'google-reviews-block__location';
      if (this.#locationIconTemplate instanceof HTMLTemplateElement) {
        location.append(this.#locationIconTemplate.content.cloneNode(true));
      }
      const locationText = document.createElement('span');
      locationText.className = 'google-reviews-block__location-name';
      locationText.textContent = locationName;
      location.append(locationText);
      footer.append(location);
    }

    const stars = document.createElement('span');
    stars.className = 'google-reviews-block__stars';
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', this.dataset.ratingLabel.replace('__RATING__', rating.toFixed(1)));
    renderRatingStars(stars);
    setRatingFill(stars, rating);
    footer.append(stars);

    if (identityAtBottom) {
      body.append(quote, footer);
      card.append(body, header);
    } else {
      body.append(footer, quote);
      card.append(header, body);
    }
    return card;
  }

  /** Populate the shared SSR presentation shell; it has no fetch/controller of its own. */
  #renderSummaryAvatars(reviews, reviewCount = 0) {
    if (!this.#summaryAvatarItems) return;
    const items = selectGoogleReviewAvatars(reviews);
    const group = this.#summaryAvatarItems.closest('.avatar-group');
    if (group) group.hidden = items.length === 0;
    const remainingCount = items.length ? Math.max(0, Math.floor(Number(reviewCount) || 0) - items.length) : 0;
    const signature = JSON.stringify([items, remainingCount]);
    if (signature === this.#avatarSignature && this.#summaryAvatarItems.children.length === items.length + Number(remainingCount > 0)) return;
    this.#avatarSignature = signature;
    const avatars = items.map(({ author, avatar }) => {
      const item = document.createElement('span');
      item.className = 'avatar-group__item';
      const media = document.createElement(avatar ? 'img' : 'span');
      media.className = 'avatar-group__media';
      if (avatar) {
        media.src = avatar;
        media.alt = author || this.dataset.authorFallbackLabel;
        media.width = 32;
        media.height = 32;
        media.loading = 'lazy';
        media.referrerPolicy = 'no-referrer';
      } else {
        media.textContent = getInitials(author);
        media.setAttribute('role', 'img');
        media.setAttribute('aria-label', author || this.dataset.authorFallbackLabel);
      }
      item.append(media);
      return item;
    });
    if (remainingCount > 0) {
      const overflow = document.createElement('span');
      overflow.className = 'avatar-group__overflow paragraph';
      overflow.setAttribute('role', 'img');
      const count = document.createElement('span');
      count.setAttribute('aria-hidden', 'true');
      // Keep the pill readable; the accessible label retains the full aggregate.
      const divisor = remainingCount >= 1000000 ? 1000000 : remainingCount >= 1000 ? 1000 : 1;
      const suffix = divisor === 1000000 ? 'M' : divisor === 1000 ? 'k' : '';
      count.textContent = Math.floor(remainingCount / divisor).toLocaleString() + suffix + '+';
      overflow.setAttribute('aria-label', this.dataset.reviewCountLabel.replace('__COUNT__', Number(reviewCount).toLocaleString()));
      overflow.append(count);
      avatars.push(overflow);
    }
    this.#summaryAvatarItems.replaceChildren(...avatars);
  }

  #renderSummary(summary) {
    this.#summary.hidden = false;
    this.#renderSummaryAvatars(this.#currentReviews, summary?.reviewCount);
    const rating = normalizeRating(summary?.rating);
    this.#summary.setAttribute('role', 'img');
    this.#summary.setAttribute('aria-label', this.dataset.ratingLabel.replace('__RATING__', rating.toFixed(1)));
    this.#summaryRating.textContent = rating.toFixed(1);
    renderRatingStars(this.#summaryStars);
    setRatingFill(this.#summaryStars, rating);
    this.#summaryCount.textContent = this.dataset.reviewCountLabel.replace(
      '__COUNT__',
      Number(summary?.reviewCount || 0).toLocaleString()
    );
    // A fallback ProductReview rating has no count to state.
    if (this.#isProductReview()) this.#summaryCount.hidden = !(Number(summary?.reviewCount) > 0);
  }

  #setLoading() {
    this.#isLoading = true;
    this.removeAttribute('data-summary-only');
    this.removeAttribute('data-unavailable');
    // Keep committed reviews and their showroom labels together until the new result commits.
    const hasContent = this.#currentReviews.length > 0 && !this.#carousel.hidden;
    this.setAttribute('aria-busy', 'true');
    if (hasContent) {
      this.removeAttribute('data-loading');
    } else {
      this.setAttribute('data-loading', '');
      this.#summary.hidden = true;
      this.#renderSummaryAvatars([]);
      const controlsHost = this.querySelector('[data-google-reviews-summary-controls]');
      if (controlsHost) { controlsHost.replaceChildren(); controlsHost.hidden = true; }
      this.#refreshMobileBleed();
      this.#restoreActionsToHome();
      this.#actionsHome.hidden = true;
      this.#actions.hidden = true;
      this.#writeLink.hidden = true;
      this.#chooseButton.hidden = true;
      this.#carousel.hidden = true;
    }
    this.#status.hidden = false;
    this.#status.classList.add('visually-hidden');
    this.#status.dataset.state = 'loading';
    this.#status.setAttribute('aria-busy', 'true');
    this.#status.replaceChildren(document.createTextNode(this.dataset.loadingLabel));
  }

  #setReady() {
    this.#isLoading = false;
    this.removeAttribute('data-loading');
    this.removeAttribute('aria-busy');
    this.#carousel.hidden = false;
    this.#refreshPagination();
    this.#status.hidden = true;
    this.#status.classList.remove('visually-hidden');
    this.#status.dataset.state = 'ready';
    this.#status.removeAttribute('aria-busy');
  }

  /** ProductReview: summary and link only; the card column is removed by CSS. */
  #setSummaryOnly() {
    this.#isLoading = false;
    this.removeAttribute('data-loading');
    this.removeAttribute('aria-busy');
    this.setAttribute('data-summary-only', '');
    this.#stopPaginationTracking();
    this.#slideshow?.remove();
    this.#slideshow = null;
    this.#carousel.hidden = true;
    this.#status.hidden = true;
    this.#status.dataset.state = 'ready';
    this.#status.removeAttribute('aria-busy');
  }

  /** ProductReview: nothing to show, so the block takes no space and announces nothing. */
  #setUnavailable() {
    this.#isLoading = false;
    this.#currentReviews = [];
    this.#currentSummary = null;
    this.removeAttribute('data-loading');
    this.removeAttribute('aria-busy');
    this.setAttribute('data-unavailable', '');
    this.#stopPaginationTracking();
    this.#slideshow?.remove();
    this.#slideshow = null;
    this.#carousel.hidden = true;
    this.#status.hidden = true;
    this.#status.removeAttribute('aria-busy');
  }

  #setEmpty() {
    this.#renderSummaryAvatars([]);
    this.#isLoading = false;
    this.removeAttribute('data-loading');
    this.removeAttribute('aria-busy');
    this.#restoreActionsToHome();
    this.#stopPaginationTracking();
    this.#slideshow?.remove();
    this.#slideshow = null;
    this.#status.hidden = false;
    this.#status.classList.remove('visually-hidden');
    this.#status.dataset.state = 'empty';
    this.#status.removeAttribute('aria-busy');
    this.#status.replaceChildren(document.createTextNode(this.dataset.emptyLabel));
    this.#carousel.hidden = true;
  }

  #setError() {
    this.#renderSummaryAvatars([]);
    this.#isLoading = false;
    this.removeAttribute('data-loading');
    this.removeAttribute('aria-busy');
    this.#restoreActionsToHome();
    this.#stopPaginationTracking();
    this.#slideshow?.remove();
    this.#slideshow = null;
    this.#status.hidden = false;
    this.#status.classList.remove('visually-hidden');
    this.#status.dataset.state = 'error';
    this.#status.removeAttribute('aria-busy');
    this.#status.replaceChildren(document.createTextNode(this.dataset.errorLabel));

    const retry = document.createElement('button');
    retry.type = 'button';
    retry.className = 'button button-secondary';
    retry.dataset.googleReviewsRetry = 'true';
    retry.textContent = this.dataset.retryLabel;
    this.#status.append(retry);
    this.#carousel.hidden = true;
  }

  #handleClick = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    if (target.closest('[data-google-reviews-retry]')) {
      event.preventDefault();
      this.#loadSelection(this.#selection);
      return;
    }

    const storeButton = target.closest('[data-google-reviews-store-id]');
    if (storeButton) {
      event.preventDefault();
      this.#loadSelection(storeButton.dataset.googleReviewsStoreId);
      return;
    }

    const toggle = target.closest('.google-reviews-block__read-more');
    const state = toggle && this.#reviewTextStates.get(toggle);
    if (state) {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      // Capture painted positions before cancelling a reversed animation or resetting scroll.
      const fromText = state.textElement.getBoundingClientRect();
      const fromRegion = state.scrollRegion.getBoundingClientRect();
      const fromToggle = toggle.getBoundingClientRect();
      const fromClip = getComputedStyle(state.textElement).clipPath;
      this.#cancelQuoteMotion(toggle);
      state.textElement.textContent = expanded ? state.shortText : state.fullText;
      state.scrollRegion.dataset.expanded = String(!expanded);
      state.scrollRegion.scrollTop = 0;
      state.scrollRegion.parentElement?.toggleAttribute('data-quote-expanded', !expanded);
      if (expanded) {
        this.#expandedQuotes.delete(state.scrollRegion);
        this.#paginationResizeObserver?.unobserve(state.scrollRegion);
        this.#paginationResizeObserver?.unobserve(state.textElement);
        state.scrollRegion.parentElement?.removeAttribute('data-quote-more-below');
        state.scrollRegion.removeAttribute('tabindex');
        state.scrollRegion.removeAttribute('role');
        state.scrollRegion.removeAttribute('aria-label');
      } else {
        this.#expandedQuotes.add(state.scrollRegion);
        this.#paginationResizeObserver?.observe(state.scrollRegion);
        this.#paginationResizeObserver?.observe(state.textElement);
        this.#scheduleQuoteRefresh();
        state.scrollRegion.setAttribute('tabindex', '0');
        state.scrollRegion.setAttribute('role', 'region');
        state.scrollRegion.setAttribute('aria-label', this.dataset.sourceLabel);
      }
      toggle.setAttribute('aria-expanded', String(!expanded));
      toggle.textContent = expanded ? this.dataset.readMoreLabel : this.dataset.readLessLabel;
      this.#animateQuote(toggle, state, { fromText, fromRegion, fromToggle, fromClip });
      return;
    }
  };

  #canAnimateQuote() {
    return !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      && !['none', 'reduced'].includes(document.body.dataset.motion);
  }

  #resolveQuoteMotionPolicy = () => {
    if (!this.#canAnimateQuote()) this.#cancelQuoteMotions();
  };

  #cancelQuoteMotion(toggle) {
    const animations = this.#quoteAnimations.get(toggle);
    this.#quoteAnimations.delete(toggle);
    animations?.forEach((animation) => animation.cancel());
    const region = this.#reviewTextStates.get(toggle)?.scrollRegion;
    if (animations && this.isConnected && region && this.#expandedQuotes.has(region) && this.contains(region)) {
      this.#scheduleQuoteRefresh();
    }
  }

  #cancelQuoteMotions() {
    for (const toggle of this.#quoteAnimations.keys()) this.#cancelQuoteMotion(toggle);
  }

  /** Animate actual text and toggle displacement inside the fixed viewport, without cloning content. */
  #animateQuote(toggle, state, { fromText, fromRegion, fromToggle, fromClip }) {
    if (!this.#canAnimateQuote() || typeof state.textElement.animate !== 'function') return;
    const text = state.textElement;
    const styles = getComputedStyle(text);
    const value = styles.getPropertyValue('--google-reviews-quote-duration').trim();
    const duration = Number.parseFloat(value) * (value.endsWith('ms') ? 1 : 1000);
    const easing = styles.getPropertyValue('--google-reviews-quote-easing').trim();
    if (!Number.isFinite(duration) || duration <= 0 || !easing) return;
    const toText = text.getBoundingClientRect();
    const toToggle = toggle.getBoundingClientRect();
    // Only visible content participates when collapsing a review scrolled away from its start.
    const insets = fromClip.match(/^inset\(([^)]+)\)/)?.[1].split(/\s+/).map(Number.parseFloat) || [];
    const clipTop = insets[0] || 0;
    const clipBottom = (insets.length > 2 ? insets[2] : insets[0]) || 0;
    const start = Math.max(fromText.top + clipTop, fromRegion.top);
    const visibleHeight = Math.max(0, Math.min(fromText.bottom - clipBottom, fromRegion.bottom) - start);
    const bottomClip = Math.max(0, toText.height - visibleHeight);
    const clip = 'inset(0px 0px ' + bottomClip + 'px 0px)';
    const animations = [text.animate([
      { transform: 'translateY(' + (start - toText.top) + 'px)', clipPath: clip },
      { transform: 'translateY(0px)', clipPath: 'inset(0px)' },
    ], { duration, easing, fill: 'both' })];
    if (Math.abs(fromToggle.top - toToggle.top) > 0.5) {
      animations.push(toggle.animate([
        { transform: 'translateY(' + (fromToggle.top - toToggle.top) + 'px)' },
        { transform: 'translateY(0px)' },
      ], { duration, easing, fill: 'both' }));
    }
    this.#quoteAnimations.set(toggle, animations);
    state.scrollRegion.parentElement?.removeAttribute('data-quote-more-below');
    Promise.allSettled(animations.map((animation) => animation.finished)).then(() => {
      if (this.#quoteAnimations.get(toggle) === animations) this.#cancelQuoteMotion(toggle);
    });
  }

  #handleChange = (event) => {
    if (event.target === this.#locationSelect) {
      this.#loadSelection(this.#locationSelect.value);
    }
  };

  /** Native auto-popover owns activation, Escape, light dismissal and focus return. */
  #handlePickerToggle = (event) => {
    if (event.target !== this.#picker) return;
    this.#pickerOpen = event.newState === 'open';
    this.#chooseButton?.setAttribute('aria-expanded', String(this.#pickerOpen));
    if (!this.#pickerOpen) {
      this.#stopPickerTracking();
      return;
    }

    this.#positionPicker();
    if (!this.#pickerOpen) {
      event.preventDefault();
      return;
    }
    const controller = new AbortController();
    this.#pickerTrackingController?.abort();
    this.#pickerTrackingController = controller;
    const { signal } = controller;
    window.addEventListener('scroll', this.#schedulePickerPosition, { capture: true, passive: true, signal });
    window.addEventListener('resize', this.#schedulePickerPosition, { passive: true, signal });
    window.visualViewport?.addEventListener('scroll', this.#schedulePickerPosition, { passive: true, signal });
    window.visualViewport?.addEventListener('resize', this.#schedulePickerPosition, { passive: true, signal });
    // Re-measure open content before paint; a closed popover has no scroll height.
    this.#schedulePickerPosition();
  };

  #schedulePickerPosition = (event) => {
    if (event?.target instanceof Element && this.#picker?.contains(event.target)) return;
    if (!this.#pickerOpen || this.#pickerFrame !== null) return;
    this.#pickerFrame = requestAnimationFrame(() => {
      this.#pickerFrame = null;
      if (this.isConnected && this.#pickerOpen) this.#positionPicker();
    });
  };

  #positionPicker() {
    if (!this.#picker || !this.#chooseButton) return;
    const visual = window.visualViewport;
    const viewport = {
      top: visual?.offsetTop ?? 0,
      left: visual?.offsetLeft ?? 0,
      bottom: (visual?.offsetTop ?? 0) + (visual?.height ?? window.innerHeight),
      right: (visual?.offsetLeft ?? 0) + (visual?.width ?? window.innerWidth),
    };
    const styles = getComputedStyle(this.#picker);
    // These real box lengths resolve rem, max() and safe-area values without a unit parser.
    const gap = parseFloat(styles.marginTop);
    const edge = parseFloat(styles.marginLeft);
    const contentHeight = this.#picker.scrollHeight
      ? this.#picker.scrollHeight + parseFloat(styles.borderTopWidth) + parseFloat(styles.borderBottomWidth)
      : viewport.bottom - viewport.top;
    const trigger = this.#chooseButton.getBoundingClientRect();
    // The menu matches its trigger so desktop and mobile share the same alignment.
    const position = getGoogleReviewsPickerPlacement(
      trigger, viewport, contentHeight,
      trigger.width || 320,
      Number.isFinite(gap) ? gap : 8,
      Number.isFinite(edge) ? edge : 16,
      styles.direction === 'rtl'
    );
    if (!position) {
      this.#closePicker();
      return;
    }
    this.#picker.dataset.placement = position.placement;
    this.#picker.style.setProperty('--google-reviews-picker-top', `${position.top}px`);
    this.#picker.style.setProperty('--google-reviews-picker-left', `${position.left}px`);
    this.#picker.style.setProperty('--google-reviews-picker-width', `${position.width}px`);
    this.#picker.style.setProperty('--google-reviews-picker-height', `${position.maxHeight}px`);
  }

  /** Keep the final anchor through native close fades; reset on replacement/disconnect. */
  #stopPickerTracking(resetGeometry = false) {
    this.#pickerTrackingController?.abort();
    this.#pickerTrackingController = null;
    if (this.#pickerFrame !== null) cancelAnimationFrame(this.#pickerFrame);
    this.#pickerFrame = null;
    if (!resetGeometry || !this.#picker) return;
    delete this.#picker.dataset.placement;
    for (const name of ['top', 'left', 'width', 'height']) {
      this.#picker.style.removeProperty(`--google-reviews-picker-${name}`);
    }
  }

  /** Restore owned focus before hiding or replacing showroom buttons. */
  #closePicker(restoreFocus = false) {
    if (restoreFocus && this.#picker?.contains(document.activeElement)) {
      this.#chooseButton?.focus({ preventScroll: true });
    }
    if (this.#pickerOpen && this.#picker?.isConnected) this.#picker.hidePopover();
    this.#pickerOpen = false;
    this.#chooseButton?.setAttribute('aria-expanded', 'false');
    this.#stopPickerTracking();
  }

  #isCurrent(generation) {
    return generation === this.#generation && !this.#controller?.signal.aborted;
  }

  #formatDate(value) {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.valueOf())) return '';
    return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' }).format(date);
  }
}

async function registerGoogleReviews() {
  await Theme.popoverPolyfillReady;
  if (!customElements.get('google-reviews-block')) {
    customElements.define('google-reviews-block', GoogleReviewsBlock);
  }
}

registerGoogleReviews();
